import React, { useRef, useState, useContext } from 'react';
import { NavLink } from 'react-router-dom';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LoginInput, PasswordInput } from '../Styled/Input';
import { CloseButton } from '../Styled/Buttons';
import {
  CardInputLabel, MyLoginButton, Form, Header, StyledInputContainer, Container,
} from './styledLoginComp';
import { Modal } from '../Styled/Misc';
import LoginContext from '../../providers/authLoginProvider';

const Err = styled.div`
  // font-weight: 700;
  color: red;
  margin-top: 5px;
`;

// function LoginForm({ onLogin, errorMsg }) {
function LoginForm() {
  const { onLogin, errorMsg } = useContext(LoginContext);
  const [showMsg, setShowMsg] = useState('');
  const loginRef = useRef();
  const passwdRef = useRef();

  return (
    <Container>
      <Form>
        <Header>Вхід до системи</Header>
        <StyledInputContainer>
          <LoginInput name="username" ref={loginRef} />
        </StyledInputContainer>
        <NavLink
          to="/resetPassword/"
          activeStyle={{
            color: '#4272d7',
            boxShadow: '2px 0 12px 0 rgb(177,177,177)',
          }}
        >
          <CardInputLabel>
            Забули пароль?
          </CardInputLabel>
        </NavLink>
        <StyledInputContainer>
          <PasswordInput
            name="password"
            type="password"
            ref={passwdRef}
            autocomplete="current-password"
          />
        </StyledInputContainer>
        <MyLoginButton
          content="Увійти"
          onClick={() => onLogin(loginRef.current.value, passwdRef.current.value)}
        />
        {errorMsg && (
        <Err>{errorMsg}</Err>
        )}
      </Form>

      {showMsg && (
        <Modal open={showMsg}>
          <>
            <h3>{showMsg}</h3>
            <div style={{ width: '300px' }}>
              <CloseButton onClick={() => { setShowMsg(false); }} />
            </div>
          </>
        </Modal>
      )}

    </Container>
  );
}

export default LoginForm;
